module.exports = __webpack_public_path__ + "tz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tz.svg
// module id = 860
// module chunks = 0